<template lang="pug">
.play-cards.profile-playcards-container
  re-toast-alert(v-if="errorMessage" type="danger") {{ errorMessage }}
  ul.play-cards__menu.menu
    li.menu__item
      a.menu__link(href="" @click.prevent="showAddModal = true") Add a {{PLAYCARD}}
    li.menu__item
      router-link.menu__link(:to="{ name: 'supercharged.buy-play-card' }") Purchase a {{PLAYCARD}}
  template(v-if="arePlaycardsLoaded")
    .play-cards__plays
      template(v-if="pages")
        .play-cards__card.play-card(v-for="playcard in playcardsPage")
          .play-card__container
            .play-card__align
              div
                p.play-card__balance-caption Balance
                p.play-card__money {{ Number(playcard.cash) + Number(playcard.bonus_cash) | currency }}
                  //- sub.play-card__points points
              template(v-if="playcard.tickets")
                div
                  .play-card__image-transfer
                div
                  p.play-card__balance-caption Tickets
                  p.play-card__money {{ playcard.tickets }}
            p.play-card__number-card.number-card
              span.number-card__code(v-for="part in playcardNumberParts(playcard.number)") {{ part }}
            p.play-card__primary-card(v-if="playcard.is_primary") PRIMARY CARD
            a.play-card__set-primary-card(v-else href="#" @click="primary(playcard)") Set as primary
          button.empty(@click="showArchiveModal = true, archivePlaycard = playcard")
            .play-card__butt Archive
          router-link.play-card__butt(:to="{ name: 'supercharged.reload-play-card', query: { number: fullPlaycardNumber(playcard.number), owner: true } }") Reload {{PLAYCARD}}
      .play-cards__card.play-card_empty(v-else)
        p.play-card_empty__text-empty No {{PLAYCARD_TC}}s have been associated to this account. To add a {{PLAYCARD_TC}}s click the button below.
    button.play-cards__add-card.site_button.site_button_inverse(@click.prevent="showAddModal = true") Add {{PLAYCARD}}
    .play-cards__pagination.pagination(v-if="pages")
      pagination(:pages="pages" v-model="page" :cookie="PAGE_COOKIE")

  substrate(v-if="showAddModal" @close="showAddModal = false" inner-class="substrate__popup-change-pass-padd")
    p Enter the number and CVV of the {{PLAYCARD_TC}} you would like to add.
    re-toast-alert.m-b-20(v-if="addingErrorMessage" type="danger") {{ addingErrorMessage }}
    form(@submit.prevent="")
      .substrate__popup-change-pass__gift_card
        label {{PLAYCARD_TC}} Number
        input(v-model="playcard.number" type="number" placeholder="XXXX XXXX XXXX XXXX" autocomplete="off")
        a(href="" @click.prevent="$refs.whatIsNumberModal.show") What is this?
      .substrate__popup-change-pass__gift_code
        label CVV
        input(v-model="playcard.cvv" type="password" placeholder="****" autocomplete="off" maxlength="4")
        a(href="" @click.prevent="$refs.whatIsCvvModal.show") What is this?
      div
        v-button.site_button(@click="add" :loading="isAdding" no-default-class) Add Card

  substrate(v-if="showAddedModal" @close="showAddedModal = false")
    p Your {{PLAYCARD_TC}} has been added.
    div
      router-link(:to="{ name: 'supercharged.buy-play-card' }")
        button.site_button.substrate__popup-change-pass__purch-card.substrate__button__full-w Purchase a {{PLAYCARD}}
      button.site_button.site_button_inverse.substrate__popup-change-pass__more-gift.substrate__button__full-w(@click.prevent="showAddModal = !(showAddedModal = false)") Add one more {{PLAYCARD_TC}}

  what-is-modal(ref="whatIsNumberModal" :img-src="`${config.baseUri}/images/supercharged/playcard-number-example.png`")
  what-is-modal(ref="whatIsCvvModal" :img-src="`${config.baseUri}/images/supercharged/playcard-cvv-example.png`")

  substrate(v-if="showArchiveModal" @close="showArchiveModal = false")
    p Do you want to archive your {{PLAYCARD_TC}}?
    re-toast-alert(v-if="archivingErrorMessage" type="danger") {{ archivingErrorMessage }}
    .substrate__popup-change-pass--archive
      v-button.site_button.site_button_inverse.substrate__popup-change-pass__more-gift(@click="archive(archivePlaycard)" :loading="isArchiving[archivePlaycard.id]" no-default-class) Yes
      button.site_button.substrate__popup-change-pass__purch-card(@click.prevent="showArchiveModal = false") No

  substrate(v-if="showArchivedModal" @close="showArchivedModal = false")
    p Your {{PLAYCARD_TC}} has been archived.
    div
      router-link(:to="{ name: 'supercharged.buy-play-card' }")
        button.site_button.substrate__popup-change-pass__purch-card.substrate__button__full-w Purchase a {{PLAYCARD}}

</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Cookies from 'js-cookie'

import { getFirstErrorMessage } from '~/lib/axios'

import ConfigMixin from '../../components/_mixins/config'
import PagesMixin from '../../components/_mixins/pages'

import Pagination from './pagination'

const PER_PAGE = 3
const PAGE_COOKIE = 'profile-playcards-page'

const mixins = [
  ConfigMixin,
  PagesMixin,
]

try {
  mixins.push(require('marketing/playcards/_mixins/playcard-list').default)
} catch (e) {}

export default {
  mixins,
  settings: 'page.profile.tab.playcards',
  translations: 'page.profile.tab.playcards',
  components: {
    Pagination,
  },

  data: () => ({
    PAGE_COOKIE,

    page: 1,
    pages: 0,

    archivePlaycard: null,

    showAddModal: false,
    showAddedModal: false,
    showArchiveModal: false,
    showArchivedModal: false,

    errorMessage: null,
  }),

  computed: {
    playcardsPage() {
      return this.playcards.slice((this.page - 1) * PER_PAGE, this.page * PER_PAGE)
    }
  },

  async created() {
    this.page = Number(Cookies.get(PAGE_COOKIE) || 1),

    this.$on('playcards.loaded', async function() {
      this.pages = Math.ceil(this.playcards.length / PER_PAGE)
      if (this.page > this.pages) {
        this.page = this.pages
      }
    })

    this.$on('playcard.added', function() {
      this.showAddModal = false
      this.showAddedModal = true
    })

    this.$on('playcard.archived', async function() {
      this.showArchiveModal = false
      this.showArchivedModal = true
    })

    await this.load()
  },

  methods: {
    fullPlaycardNumber(number) {
      number = String(number)
      const remaining = 16 - number.length
      return remaining > 0 ? '0'.repeat(remaining) + number : number
    },

    playcardNumberParts(number) {
      number = String(number)

      const remaining = 16 - number.length
      if (remaining > 0) {
        number = '0'.repeat(remaining) + number
      }

      const partCount = number.length / 4
      const parts = []
      for (let i = 0; i < partCount; i++) {
        parts.push(number.substring(i * 4, (i + 1) * 4))
      }

      return parts
    }
  },
}
</script>

<style lang="scss">
.page-body-content.page-general-body-content {
  // max-width: unset;
  .my-account-navigation {
    margin: auto;
  }
}

.play-cards.profile-playcards-container {
  display: block;

  button.btn.btn-link {
    padding: 0;
    border: 0;
    height: fit-content;
  }

  button.empty {
    padding: 0;
    border: 0;
    border-radius: 0;
    background-color: unset;
  }

  .substrate__popup-change-pass input {
    border: 1px solid #BEBEBE;
  }
}

@media screen and (max-width: 375px) {
  .play-card__container:before {
    background-size: 100% 100%;
  }
  .play-card_empty,
  .play-card__container {
    height: 160px;
  }
}
</style>
